import styles from './style.module.css';
import { URL } from "../../utils/constants";
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = ({ loggedIn, onSignOut }) => {
  const token = localStorage.getItem('auth_token');
  const [user, setUser] = useState(null);

  useEffect(() => {
    const headers = token ? { Authorization: `Token ${token}` } : {};
    fetch(`${URL}/api/users/me/`, {
      mode: 'cors',
      method: 'GET',
      headers,
    })
      .then(async (response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then(data => setUser(data))
      .catch(() => setUser(null));
  }, [token]);

  // Показываем: имя -> логин -> "Гость"
  const displayName = (user?.first_name?.trim())
    ? user.first_name.trim()
    : (user?.username || null);

  const isAuthed = !!displayName; // если есть имя или логин — считаем авторизован

  return (
    <>
      <header className={styles.header}>
        <div className={styles.user}>
          {isAuthed ? `Привет, ${displayName}` : "Гость"}
          <span className={styles.separator}></span>
        </div>
        <nav className={styles.nav}>
          <Link to="/" className={styles.button}>Главная</Link>

          {isAuthed ? (
            <>
              <button className={styles.button} onClick={onSignOut} type="button">
                Выйти
              </button>
              <button
                type="button"
                className={styles.toolsTrigger}
                onClick={() => window.dispatchEvent(new CustomEvent("gm:toggleMobileToolbar"))}
                aria-label="Инструменты"
                title="Инструменты"
              >
                ≡
              </button>
            <button
              type="button"
              className={styles.toolsTrigger}
              onClick={() => window.dispatchEvent(new CustomEvent("gm:toggleMobileToolsDrawer"))}
              aria-label="Инструменты карты"
              title="Инструменты карты"
            >
              ✎
            </button>
          </>
          ) : (
            <Link to="/signin" className={styles.button}>
              Войти
            </Link>
          )}
        </nav>
      </header>
    </>
  );
};

export default Header;
